import React, { useEffect } from 'react';
import './App.css';

function App() {
  // Add scroll effect for the second design
  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll('.fade-in');
      elements.forEach((element) => {
        const elementTop = element.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        if (elementTop < windowHeight - 100) {
          element.classList.add('active');
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    // Initial check in case elements are already in view
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      {/* First Design */}
      <div className="cyberpunk-container first-design">
        <div className="corner-element top-left"></div>
        <div className="corner-element top-right"></div>
        <div className="corner-element bottom-left"></div>
        <div className="corner-element bottom-right"></div>
        
        <header className="cyberpunk-header">
          <h1 className="cyberpunk-title">Cyber Punk</h1>
        </header>
        
        <main className="cyberpunk-content">
          <section className="cyberpunk-section stories-section">
            <div className="section-content">
              <h2>Stories & Lore</h2>
              <p>Dive into compelling narratives set in a dystopian future.</p>
            </div>
          </section>
          
          <section className="cyberpunk-section events-section">
            <div className="section-content">
              <h2>Events and Updates</h2>
              <p>Stay updated with the latest events and updates from the cyberpunk universe.</p>
              <button className="cyberpunk-button">View All Events</button>
            </div>
          </section>
          
          
          <section className="cyberpunk-section experience-section">
            <div className="experience-card">
              <div className="experience-number">76,285K+</div>
              <h3>Experience the Future</h3>
              <p>Explore the high-tech, low-life world where the lines between</p>
            </div>
            
            <div className="experience-card">
              <h3>Art and Design</h3>
              <p>Explore stunning cyberpunk artwork and designs from talented creators.</p>
            </div>
            
            <div className="experience-card">
              <div className="experience-number">1 7+</div>
              <h3>Years of Experience</h3>
            </div>
          </section>
        </main>
      </div>

      {/* Second Design */}
      <div className="cyberpunk-container second-design">
        <main className="cyberpunk-content">
          <section className="hero-section">
            <div className="hero-text">
              <h1 className="hero-title">
                Where <span className="text-orange">Neon Dreams</span><br />
                <span className="text-orange">&</span> <span className="text-orange">Digital</span> Nightmares<br />
                Converge.
              </h1>
              <p className="hero-description">
                A realm where advanced technology meets dystopian reality. Our website
                is your gateway to a universe of neon lights, gritty streets, and cybernetic
                enhancements. Explore the high-tech, low-life world where the lines
                between humanity and machinery blur.
              </p>
            </div>
            <div className="hero-image">
              <img 
                src="https://images.unsplash.com/photo-1485827404703-89b55fcc595e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80" 
                alt="Cyberpunk cityscape"
                className="image-placeholder"
              />
            </div>
          </section>

          <section className="stats-section">
            <div className="stat-card">
              <h3 className="stat-number text-orange">89,2K+</h3>
              <p className="stat-label">Discover the Future</p>
            </div>
            
            <div className="stat-card">
              <h3 className="stat-number text-orange">7001+</h3>
              <p className="stat-label">Stories and Lore</p>
            </div>
            
            <div className="stat-card">
              <h3 className="stat-number text-orange">3,124+</h3>
              <p className="stat-label">Art and Design</p>
            </div>
          </section>

          <section className="feature-section">
          <div className="hero-image">
              <img 
                src="https://wallpapers-clan.com/wp-content/uploads/2025/04/gta-city-lights-palm-trees-sunset-drive-desktop-wallpaper-preview.jpg" 
                alt="Cyberpunk cityscape"
                className="image-placeholder"
              />
            </div>
            
            <div className="feature-text">
              <h2 className="feature-title">
                Unveil <span className="text-orange">the Secrets<br />
                of the</span> Cybernetic<br />
                Underworld
              </h2>
              <p className="feature-description">
                A realm where advanced technology meets dystopian reality. Our
                website is your gateway to a universe of neon lights, gritty streets,
                and cybernetic enhancements.
              </p>
              
              <div className="join-card">
                <div className="join-image">
                  <div className="image-placeholder small">
                  <img 
                src="https://wallpapers-clan.com/wp-content/uploads/2024/12/hacker-digital-screens-cyberpunk-desktop-wallpaper-preview.jpg" 
                alt="Cyberpunk cityscape"
                 className="image-placeholder small"
                
              />
                  </div>
                </div>

                

                <div className="join-text">
                  <h3 className="join-title">Join the Revolution</h3>
                  <p className="join-description">
                    Explore the high-tech, low-life world where the lines between
                    humanity and machinery blur.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </main>
        
        <div className="corner-element top-left"></div>
        <div className="corner-element top-right"></div>
        <div className="corner-element bottom-left"></div>
        <div className="corner-element bottom-right"></div>
      </div>
    
      
      
      {/* Cybernetic Universe Section */}
      <div className="cyberpunk-container cybernetic-universe">
        <div className="section-content">
          <div className="cybernetic-content">
            <h1>Dive into the Cybernetic</h1>
            <h2 className="section-title">Universe</h2>
            <p className="section-subtitle">
              A realm where advanced technology meets dystopian reality. Our website is your gateway to a universe of neon lights, gritty streets, and cybernetic enhancements.
            </p>
            
            <div className="cybernetic-features">
              <div className="feature">
                <div className="feature-icon">
                  <div className="icon-circle">
                    <span>01</span>
                  </div>
                </div>
                <h3>Discover the Future</h3>
                <p>Explore the high-tech, low-life world where the lines between humanity</p>
              </div>
              
              <div className="feature">
                <div className="feature-icon">
                  <div className="icon-circle">
                    <span>02</span>
                  </div>
                </div>
                <h3>Explore Features</h3>
                <p>Explore the high-tech, low-life world where the lines between humanity</p>
              </div>
              
              <div className="feature">
                <div className="feature-icon">
                  <div className="icon-circle">
                    <span>03</span>
                  </div>
                </div>
                <h3>Stay Connected</h3>
                <p>Explore the high-tech, low-life world where the lines between humanity</p>
              </div>
            </div>
            
            <div className="cybernetic-cta">
            <div className="hero-image">
              <img 
                src="https://wallpapers-clan.com/wp-content/uploads/2025/01/wild-west-gunslingers-dusty-scene-desktop-wallpaper-cover.jpg" 
                alt="Cyberpunk cityscape"
                className="image-placeholder"
              />
            </div>
              <div className="cta-card">
                <h3>Your Portal to a Gritty, Tech-Driven Future.</h3>
                <p>A realm where advanced technology meets dystopian reality. Our website is your gateway to a universe of neon lights, gritty streets, and cybernetic enhancements.</p>
                <div className="cta-buttons">
                  <button className="cyberpunk-button primary">Read More</button>
                  <button className="cyberpunk-button secondary">Learn More</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* FAQ Section */}
      <div className="cyberpunk-container faq-section">
        <div className="section-content">
          <h2 className="section-title">Frequently Asked Questions</h2>
          <p className="section-subtitle">
            A realm where advanced technology meets dystopian reality. Our website is your gateway to a universe of neon lights, gritty streets, and cybernetic enhancements.
          </p>
          
          <div className="faq-grid">
            <div className="faq-item">
              <div className="faq-number">01.</div>
              <div className="faq-content">
                <h3>How do I stay updated on new content and events?</h3>
                <p>A realm where advanced technology meets dystopian reality. Our website is your gateway....</p>
              </div>
            </div>
            
            <div className="faq-item">
              <div className="faq-number">02.</div>
              <div className="faq-content">
                <h3>How can I contact customer cyber punk support?</h3>
                <p>A realm where advanced technology meets dystopian reality. Our website is your gateway....</p>
              </div>
            </div>
            
            <div className="faq-item">
              <div className="faq-number">03.</div>
              <div className="faq-content">
                <h3>Can I purchase cyberpunk-themed merchandise?</h3>
                <p>A realm where advanced technology meets dystopian reality. Our website is your gateway....</p>
              </div>
            </div>
            
            <div className="faq-item">
              <div className="faq-number">04.</div>
              <div className="faq-content">
                <h3>Are there any rules or guidelines for participating in the community?</h3>
                <p>A realm where advanced technology meets dystopian reality. Our website is your gateway....</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Footer */}
      <footer className="cyberpunk-footer">
        <div className="footer-content">
          <div className="footer-brand">
            <h3>Cyber.AI - Cyber Punk Website</h3>
            <p>Explore the high-tech, low-life world where the lines between humanity and technology blur.</p>
          </div>
          
          <div className="footer-links">
            <div className="footer-column">
              <h4>Information</h4>
              <ul>
                <li><a href="#">Press Centre</a></li>
                <li><a href="#">Our Blog</a></li>
                <li><a href="#">Term and Condition</a></li>
              </ul>
            </div>
            
            <div className="footer-column">
              <h4>Menu</h4>
              <ul>
                <li><a href="#">About</a></li>
                <li><a href="#">Services</a></li>
                <li><a href="#">Blog</a></li>
              </ul>
            </div>
            
            <div className="footer-column">
              <h4>Contact</h4>
              <ul className="contact-info">
                <li>Phone: +123 456 789</li>
                <li>Email: example@cyberpunk.ai</li>
                <li>Address Line 01</li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>© Cyber.AI - Cyber Punk 2024. All rights reserved.</p>
          <div className="footer-legal">
            <a href="#">Terms</a>
            <a href="#">Privacy</a>
            <a href="#">Cookies</a>
          </div>
        </div>
      </footer>
    </>
  );
}

export default App;
